<template>
  <div id="hres7de-detail-tab4" class="panel box-collapse border-color-skin">
    <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#tab4">
      <h3 class="box-title">
        <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES7DEP4']['10'] }}
      </h3>
    </div>
    <div id="tab4" class="panel-collapse collapse tab-detail">
      <div class="panel-body">   
          <div class="detail detail-responsive">
            <div class="col-md-6">
              <form class="form-horizontal">
                <div class="form-group margin-b-5">
                  <label class="col-md-4 control-label">{{ labels['HRES7DEP4']['20'] }}</label>
                  <div class="col-md-6">
                    <textarea class="form-control" 
                              v-model="detailTab4.dessummary"
                              maxlength="600" 
                              v-validate="'max:600'"
                              data-vv-name="dessummary"
                              :has-error="errors.has('dessummary')"></textarea>
                    <div class="text-error" v-show="errors.has('dessummary')">{{errors.first('dessummary')}}</div>
                    <div class="remark-limit-character">{{ dispLimitLabel(600) }}</div> 
                  </div>
                </div>
              </form>
              <form class="form-horizontal">
                <div class="form-group margin-b-5">
                  <label class="col-md-4 control-label">{{ labels['HRES7DEP4']['40'] }}</label>
                  <div class="col-md-6">
                    <textarea class="form-control"
                              v-model="detailTab4.desbenefit"
                              maxlength="600"
                              v-validate="'max:600'"
                              data-vv-name="desbenefit"
                              :has-error="errors.has('desbenefit')"></textarea>
                    <div class="text-error" v-show="errors.has('desbenefit')">{{errors.first('desbenefit')}}</div>
                    <div class="remark-limit-character">{{ dispLimitLabel(600) }}</div>
                  </div>
                </div>
              </form>
            </div>

            <div class="col-md-6">
              <form class="form-horizontal">
                <div class="form-group margin-b-5">
                  <label class="col-md-4 control-label">{{ labels['HRES7DEP4']['30'] }}</label>
                  <div class="col-md-6">
                    <textarea class="form-control" 
                              v-model="detailTab4.descomment"
                              maxlength="600" 
                              v-validate="'max:600'"
                              data-vv-name="descomment"
                              :has-error="errors.has('descomment')"></textarea>
                    <div class="text-error" v-show="errors.has('descomment')">{{errors.first('descomment')}}</div>
                    <div class="remark-limit-character">{{ dispLimitLabel(600) }}</div> 
                  </div>
                </div>
              </form>
            </div>
            <div class="col-md-12">
              <button type="button" class="btn bg-color-skin" @click="save()"><i class="fa fa-check-circle"></i>{{ labelsButton['save'] }}</button>  
            </div>


          </div>
      </div>
    </div>
  </div>
</template>

<script>
import { constLabels } from 'assets/js/constLabels.js'

export default {
  name: 'hres7de-detail-tab4',
  props: [ 'labels', 'detailTab4', 'labelsButton', 'postHres7deTab4Save', 'searchIndex', 'indexSelected', 'searchDetail' ],
  methods: {
    dispLimitLabel (limit) {
      return constLabels('limitTo') + ' ' + limit + ' ' + constLabels('characters')
    },
    saveParams () {
      this.detailTab4.codcours = this.indexSelected.codcours
      this.detailTab4.numclseq = this.indexSelected.numclseq
      return {
        searchIndex: this.searchIndex,
        searchDetail: this.searchDetail,
        detailTab4: this.detailTab4
      }
    },
    save () {
      let _this = this
      this.$validator.validateAll().then(result => {
        if (result) {
          _this.postHres7deTab4Save(_this.saveParams())
        }
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// detailTab4.vue?c47a974a